import { SET_FEATURES, SET_IS_LOADING } from '../actionTypes/index';

const initialState = {
  features: {},
  isLoading: false
}

export default  (state = initialState, action) => {
  switch (action && action.type) {
    case SET_FEATURES:
      return {
        ...state,
        features: action.payload
      };

    case SET_IS_LOADING:
      return {
        ...state,
        isLoading: action.payload
      };

    default:
      return state;
  }
}
